var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.containerStyle),attrs:{"hakka-player":"youtube-container"}},[(!_vm.disabled && !_vm.cannotView)?_c('div',{style:(_vm.containerStyle)},[_c('div',{attrs:{"id":_vm.elementId}})]):_c('v-img',{attrs:{"src":_vm.disablePhotoUrl,"height":"100%","contain":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }